import { c as _c } from "react/compiler-runtime";
import { getTimeAgoShort } from "@/helpers/Helpers";
import { assertUnreachable } from "@/helpers/AllowlistToolHelpers";
import DropAuthorHandle from "./DropAuthorHandle";
import UserCICAndLevel, { UserCICAndLevelSize } from "@/components/user/utils/UserCICAndLevel";
import { DropPartSize } from "@/components/drops/view/part/DropPart.types";
import type { ProfileMinWithoutSubs } from "@/helpers/ProfileTypes";
interface DropAuthorProps {
  readonly profile: ProfileMinWithoutSubs;
  readonly timestamp: number;
  readonly size?: DropPartSize | undefined;
  readonly children?: React.ReactNode | undefined;
}
export default function DropAuthor(t0) {
  const $ = _c(21);
  const {
    profile,
    timestamp,
    size: t1,
    children
  } = t0;
  const size = t1 === undefined ? DropPartSize.MEDIUM : t1;
  let t2;
  if ($[0] !== size) {
    t2 = () => {
      switch (size) {
        case DropPartSize.SMALL:
          {
            return "tw-text-sm";
          }
        case DropPartSize.MEDIUM:
        case DropPartSize.LARGE:
          {
            return "tw-text-md";
          }
        default:
          {
            assertUnreachable(size);
            return "";
          }
      }
    };
    $[0] = size;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const getTextClasses = t2;
  const textClasses = getTextClasses();
  let t3;
  if ($[2] !== profile.level) {
    t3 = <UserCICAndLevel level={profile.level} size={UserCICAndLevelSize.SMALL} />;
    $[2] = profile.level;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== profile || $[5] !== size) {
    t4 = <DropAuthorHandle profile={profile} size={size} />;
    $[4] = profile;
    $[5] = size;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <div className="tw-flex tw-items-center tw-gap-x-2 tw-text-center">{t3}{t4}</div>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== children || $[11] !== t5) {
    t6 = <div className="tw-flex tw-items-center">{t5}{children}</div>;
    $[10] = children;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const t7 = `${textClasses} tw-mb-0 tw-whitespace-nowrap tw-font-normal tw-leading-none tw-text-iron-500`;
  let t8;
  if ($[13] !== timestamp) {
    t8 = getTimeAgoShort(timestamp);
    $[13] = timestamp;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t7 || $[16] !== t8) {
    t9 = <p className={t7}>{t8}</p>;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t6 || $[19] !== t9) {
    t10 = <div className="tw-flex tw-items-center tw-w-full tw-gap-x-2">{t6}{t9}</div>;
    $[18] = t6;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  return t10;
}